export const EOldType = {
  IsChildren: 0,

  IsAdult: 1,
} as const

export type EOldType = (typeof EOldType)[keyof typeof EOldType]
